import { render } from "./UnmuteIcon.svg?vue&type=template&id=1b984158"
const script = {}
script.render = render

export default script